var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex align-items-center",
      class: [
        {
          "justify-content-end": _vm.searchActive,
          "justify-content-between": !_vm.searchActive
        },
        _vm.main_cls,
        _vm.input_elm_width
      ],
      attrs: { "data-search-bar": "" }
    },
    [
      typeof _vm.title !== "undefined" &&
      _vm.title !== null &&
      _vm.searchActive === false
        ? _c("div", [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c(
                  "add_to_bookmark",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.readBookmark() !== null,
                        expression: "readBookmark() !== null"
                      }
                    ],
                    staticClass:
                      "btn btn-info btn-floating btn-sm p-0 m-0 mr-1",
                    attrs: {
                      "data-element-type": "add_to_bookmark",
                      store: _vm.readBookmark("store"),
                      route: _vm.readBookmark("route")
                    }
                  },
                  [
                    _vm._v(
                      "\n                add to bookmark component\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                typeof _vm.show_refresh != "undefined"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "btn btn-secondary btn-floating btn-sm p-0 m-0 mr-1",
                        attrs: { "data-element-type": "refresh-results" },
                        on: {
                          click: function($event) {
                            _vm.$emit("refresh_event")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("refresh")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", { staticClass: "p-0 h3-responsive" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.input_elm_width,
          attrs: { "data-ref": "searchBar-container" }
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              class: {
                "justify-content-end": _vm.direction != "ltr",
                "justify-content-start": _vm.direction == "ltr"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "search-bar--input-wrapper",
                  class: _vm.input_elm_width
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchResultModel,
                        expression: "searchResultModel"
                      }
                    ],
                    ref: "search",
                    staticClass: "watch-transition--slow",
                    class: {
                      "search-bar--open": _vm.searchActive,
                      "search-bar--input-open": _vm.searchActive,
                      "search-bar--closed": !_vm.searchActive,
                      "search-bar--input-closed": !_vm.searchActive,
                      "search-bar-input--ltr": _vm.direction == "ltr",
                      "search-bar-input--rtl": _vm.direction != "ltr"
                    },
                    attrs: {
                      type: "text",
                      placeholder: _vm.limit_text,
                      "aria-label": _vm.limit_text,
                      title: "search"
                    },
                    domProps: { value: _vm.searchResultModel },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.submit_event()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchResultModel = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade_fast" } }, [
                _vm.searchActive
                  ? _c(
                      "div",
                      {
                        staticClass: "search-bar-close-button",
                        attrs: { "data-search-close-before": "" },
                        on: {
                          click: function($event) {
                            _vm.close_search()
                          }
                        }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            attrs: { "aria-hidden": "true" }
                          },
                          [_vm._v("close")]
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "search-bar-button",
                        attrs: { "data-direction": _vm.direction },
                        on: {
                          click: function($event) {
                            _vm.searchActive = true
                          }
                        }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            attrs: { "aria-hidden": "true" }
                          },
                          [_vm._v("search")]
                        )
                      ]
                    )
              ])
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5330ed8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5330ed8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/SearchBar.vue
// module id = 341
// module chunks = 0